'use strict';

var _ = require('lodash');
var CompetitorFaresChartTransformerFactory = function CompetitorFaresChartTransformerFactory(DataTransformer, compFareService) {
  function CompetitorFaresChartTransformer() {
    DataTransformer.call(this);
    this.sourceType = ['service-competitor-fare', 'market-product-group-competitor-fare'];
    this.targetType = 'competitor-fares-chart';
    this.priority = 1;
  }
  CompetitorFaresChartTransformer.prototype = Object.create(DataTransformer.prototype);
  CompetitorFaresChartTransformer.constructor = CompetitorFaresChartTransformer;
  CompetitorFaresChartTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) > -1 && this.targetType === targetType;
  };
  CompetitorFaresChartTransformer.prototype.isCacheable = function () {
    return true;
  };
  CompetitorFaresChartTransformer.prototype.getCacheKey = function (metrics, metricDescriptor) {
    var selectedServiceId = metricDescriptor && metricDescriptor.params ? '-' + metricDescriptor.params.selectedService : '';
    return this.sourceType.join('-') + '-' + this.targetType + selectedServiceId;
  };
  CompetitorFaresChartTransformer.prototype.transform = function (data, metrics, metricDescriptor) {
    var curveData = data && data.domain ? data.domain.competitorFareCurves : [];
    var totalResult = {
      compData: [],
      compCarriers: []
    };
    if (curveData.length === 0) {
      return totalResult;
    }
    var selectedService = metricDescriptor && metricDescriptor.params ? metricDescriptor.params.selectedService : '';
    var preparedData = compFareService.filterDataAndPrepareCurve(curveData, selectedService);
    totalResult.compCarriers = compFareService.getCompetitorCarriers(curveData);
    totalResult.compData = _.chain(preparedData).values().sortBy(['isHostFare', 'carrier']).value();
    return totalResult;
  };
  return CompetitorFaresChartTransformer;
};
CompetitorFaresChartTransformerFactory.$inject = ['DataTransformerFactory', 'CompetitorFaresChartTransformationService'];
module.exports = CompetitorFaresChartTransformerFactory;